import React from "react";
import {Headings} from "../../elements/Headings/Headings";
import {Paragraph} from "../../elements/Paragraph/Paragraph";
import {Breadcrumbs} from "../../blocks/Breadcrumbs/Breadcrumbs";
import Image from "../../elements/Image/Image";

export const PageHeader = ({ settings }) => {

    return (
        <div className="blog-list">
            <div className={'relative top-0'}>
                <div className={'w-full'}>
                    <Image imageUrl={settings.bg_image} />
                </div>
                <div className={'header-content container'}>
                    <div className={'absolute top-14'}>
                        <Breadcrumbs crumbs={[]} />
                        <Headings text={settings.title} type={"h1"} />
                        <Paragraph text={settings.content} />
                    </div>
                </div>
            </div>
        </div>
    )
}

PageHeader.propTypes = {};
